import { cx } from 'class-variance-authority'
import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-display',
        'text-headline',
        'text-title-xl',
        'text-title-lg',
        'text-title-md',
        'text-title-sm',
        'text-title-xs',
        'text-title-2xs',
        'text-heading-sm',
        'text-body-xl',
        'text-body-lg',
        'text-body-md',
        'text-body-md-strong',
        'text-body-sm',
        'text-body-sm-strong',
        'text-body-xs',
        'text-body-xs-strong',
        'text-body-xxs',
        'text-body-xxs-strong',
        'text-label-md',
        'text-label-md-strong',
        'text-label-sm',
      ],
    },
  },
})

export function cn(...inputs: Parameters<typeof cx>) {
  return customTwMerge(cx(inputs))
}
